import { utils as appMainUtils } from '@edf-pkg/app-main';

import { axios } from '$app-web/api/axios';

import { Endpoints } from '../constant';

export async function joinStudy(registrationCode: number) {
    const deviceId = appMainUtils.user.getDeviceId();

    const formData = new FormData();
    formData.append('device_id', deviceId);
    formData.append('reg_code', `${registrationCode}`);

    try {
        const { status } = await axios.post(Endpoints.StudyRegistration.Join, formData, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        });

        return status === 200;
    } catch (error) {
        throw new Error('Failed to join study');
    }
}
